import { FieldErrors, FieldValues } from "react-hook-form";

export function getValueByPath<T>(obj: {}, path: string): T {
    return path.split(".").reduce((acc, part) => acc && acc[part as keyof typeof acc], obj) as T;
}

export function findFirstError<T extends FieldValues>(errorObject: FieldErrors<T>) {
    if (!errorObject || typeof errorObject !== "object") return null;

    for (const key in errorObject) {
        const value = errorObject[key as keyof typeof errorObject];

        if (value && typeof value === "object" && "message" in value && "type" in value) {
            return value.message;
        }

        if (typeof value === "object") return findFirstError(value as FieldErrors);
    }

    return null;
}

export const groupArray = <T>(array: T[], groupSize: number) => {
    if (!Array.isArray(array) || groupSize <= 0) {
        throw new Error("Invalid input: Provide a valid array and a positive group count.");
    }

    const result: T[][] = [];

    for (let i = 0; i < array.length; i += groupSize) {
        result.push(array.slice(i, i + groupSize));
    }

    return result;
};
